import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { OverlayPanel } from "primereact/overlaypanel";

//utiltes
import { srcImagesFile } from "../../../utilities/FileUtil";

export default function P244PicList({ data, dialog, setDialog, op, toggle }) {
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);

    const carouselResponsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 3,
            numScroll: 3,
        },
        {
            breakpoint: "768px",
            numVisible: 2,
            numScroll: 2,
        },
        {
            breakpoint: "560px",
            numVisible: 1,
            numScroll: 1,
        },
    ];

    const carouselItemTemplate = (product) => {
        return (
            <div className="product-item ">
                <div className="product-item-content" style={{}}>
                    <div className="p-mb-3">
                        <img {...srcImagesFile(product.photoPath)} alt={product.name} className="product-image" style={{ width: 95, height: 100 }} onClick={toggle} />
                        <OverlayPanel ref={op} appendTo={document.body} showCloseIcon>
                            <img {...srcImagesFile(product.photoPath)} style={{ width: 400, height: 400 }} alt={product.nam} />
                        </OverlayPanel>
                    </div>
                    <div>
                        <h6 className="p-mb-2">{product.name}</h6>
                    </div>
                </div>
            </div>
        );
    };

    const onCloseMain = () => {
        setDialog({ dialog: false, show: true });
    };

    return (
        <>
            <Dialog header="แสดงรูปประกอบการประเมิน แบบที่1" visible={dialog.dialog} style={{ width: "80vw" }} className="p-fluid ___widthDialog" onHide={() => onCloseMain()} blockScroll={true} className="p-fluid" maximizable={true}>
                <Loading loading={loading} />
                <Toast ref={toast} position="top-right" />
                <div className="p-grid crud-demo">
                    <div className="p-col-12">
                        <div className="p-grid p-fluid media-demo">
                            <div className="p-col-12">
                                <div className="card">
                                    <div className="p-grid  p-fluid">
                                        <div className="p-col-12 p-md-12">
                                            <Carousel value={data} numVisible={4} numScroll={3} responsiveOptions={carouselResponsiveOptions} itemTemplate={carouselItemTemplate}></Carousel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
